import useCookieConsent from '@modules/modules/CookieConsent/components/Context';
import React, { useEffect, useState } from 'react';

const CheckConsent = ({
  services,
  children,
  noConsent,
  as: Tag = 'div',
  ...props
}) => {
  const context = useCookieConsent();
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    if (context.dataService) {
      context.dataService.setVisibleServiceGroup(
        context.dataService.getServiceGroup(services),
      );
    }

    if (navigator?.doNotTrack === true) {
      setEnabled(false);
    } else {
      setEnabled(
        services.filter(x => !context.services.includes(x)).length === 0,
      );
    }
  }, [services, context.services]);

  const NoConsent = noConsent || null;

  return <Tag {...props}>{enabled ? { ...children } : <NoConsent />}</Tag>;
};

export default CheckConsent;
